import React, { useState, useEffect } from "react";
import loading from "@assets/images/loading-card.svg";

const SalePopup = ({
  sliders,
  card,
  show,
  saleStatus,
  onClose,
  onCancel,
  onSale,
  onChangePrice,
}) => {
  const [imgSrc, setImgSrc] = useState(card.image);
  const [activePrice, setActivePrice] = useState(card.originalPrice);

  const handleChange = (newPrice) => {
    onChangePrice(newPrice);
    setActivePrice(newPrice);
  };

  const handleError = () => {
    setImgSrc(loading);
  };

  useEffect(() => {
    setActivePrice(card.originalPrice);
  }, [card.originalPrice, show]);

  return (
    <div className="salepopup">
      <div className="close-btn__wrapper" onClick={onClose}>
        <div className="close-btn__bar bar1"></div>
        <div className="close-btn__bar bar2"></div>
      </div>
      <h1 className="salepopup__title">
        {saleStatus === "Sell"
          ? `Sell ${card.name}`
          : `Cancel ${card.name} Sale`}
      </h1>
      <div className="salepopup__info-box">
        <div className="salepopup__info-box-left">
          <div className="mint-card">
            <img className="nft-img" src={imgSrc} alt="NFT" onError={handleError}></img>
          </div>
        </div>

        <div className="salepopup__info-box-right">
          <table className="sale-price">
            <tbody>

              <tr>
                <td className="table-text-data">
                  <h3 className="card__title">
                    {card.name}
                  </h3>
                </td>
              </tr>

              <tr>
                <td className="table-text-data">
                  <span>
                    {card.address.slice(0, 6)}...{card.address.slice(card.address.length - 4)}
                  </span>
                </td>
              </tr>

              <tr>
                <td className="table-text-data">Last Price:</td>
                <td className="table-text-data">{card.originalPrice} AVAX</td>
              </tr>
              <tr>
                <td className="table-text-data">Sell Price (AVAX):</td>
                <td className="table-text-data">
                  {saleStatus === "Sell" ? (
                    <input
                      className="sale-price__input"
                      onInput={(e) => handleChange(e.target.value)}
                      type="number"
                      min="0"
                      step=".01"
                      placeholder={card.originalPrice}
                      value={activePrice}
                    ></input>
                  ) : (
                    `${card.price} AVAX`
                  )}
                </td>
              </tr>
            </tbody>
          </table>
          {saleStatus === "Sell" ? (
            <button
              className="sale-btn"
              onClick={onSale}
              disabled={
                activePrice === "" || activePrice === undefined ? true : false
              }
            >
              Place your NFT for Sale
            </button>
          ) : (
            <button className="sale-btn" onClick={onCancel}>
              Cancel Sale
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default SalePopup;
